import React, { memo } from "react";
import SilkImage from "./SilkImage";
import ConfidencePill from "./ConfidencePill";

function HorseRow({ horse, dummyOdd = "-", showHotIcon = false, showPrediction = true }) {
  const isTop = showPrediction && horse.rank === 1;

  return (
    <div
      className={`horse-row grid gap-2 items-center md:p-4 p-3 border-t border-[var(--color-border)] ${
        showPrediction
          ? "md:grid-cols-[22px_40px_1fr_80px] grid-cols-[16px_32px_1fr_64px]"
          : "md:grid-cols-[40px_1fr] grid-cols-[32px_1fr]"
      } ${isTop ? "bg-[rgba(200,255,0,0.12)]" : "bg-transparent"}`}
    >
      {/* Rank */}
      {showPrediction && (
        <div
          className={`tabular horse-rank xl:text-lg md:text-base text-sm font-bold ${
            isTop ? "text-[var(--color-primary)]" : "text-[var(--color-text)]"
          }`}
        >
          {horse.rank}
        </div>
      )}

      {/* Silk */}
      <SilkImage url={horse.silk_url} />

      {/* Name + meta row */}
      <div className="min-w-0">
        <div className="flex items-center md:gap-2 gap-1.5">
          {horse.horse_number && (
            <span
              className={`tabular inline-flex items-center justify-center md:w-6 md:h-6 w-5 h-5 rounded-lg md:text-xs text-[10px] font-extrabold shrink-0 ${
                isTop ? "bg-[var(--color-primary)] text-black" : "bg-[rgba(200,255,0,0.12)] text-[var(--color-text)]"
              }`}
            >
              {horse.horse_number}
            </span>
          )}
          <span className="horse-name xl:text-base md:text-sm text-xs font-semibold text-[var(--color-text)] truncate">
            {horse.horse_name}
          </span>
        </div>
        <div className="flex items-center gap-3 mt-1 xl:text-sm md:text-xs text-[10px] text-[var(--color-text-muted)] min-w-0">
          {horse.jockey && (
            <span className="flex items-center gap-1 text-[var(--color-text)] truncate md:max-w-none max-w-[90px]">
              {horse.jockey}
            </span>
          )}
          {horse.original_weight && (
            <span className="tabular flex items-center gap-1 text-[var(--color-text-muted)] shrink-0">
              {horse.original_weight}
            </span>
          )}
        </div>
      </div>

      {/* Confidence */}
      {showPrediction && (
        <div className="flex justify-end items-center">
          <ConfidencePill score={horse.prediction_prob} showHotIcon={showHotIcon} />
        </div>
      )}

      {/* Ladbrokes Dummy Odds */}
      {/* {showPrediction && (
        <div className="flex justify-center items-center w-[74px] self-stretch bg-transparent border-l border-[rgba(5,197,34,0.1)]">
          <span className="tabular text-[var(--color-text)] xl:text-base md:text-sm text-xs font-medium">
            {dummyOdd}
          </span>
        </div>
      )} */}
    </div>
  );
}

export default memo(HorseRow);
